// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"n4-z"};